import { useSelector } from "react-redux";
import { Skeleton } from "antd";
import DashboardBadge from "../DashboardBadge";
import DashboardPreviewInfo from "../DashboardPreviewInfo";

function MarketPreview() {
  const {
    dashboard: {
      analyticsinfo: {
        collapsed_preview: { summary_text = "", badge_text = "" } = {},
      },
      analyticsinfoStatus,
    },
  } = useSelector((state) => state);

  return (
    <>
      {analyticsinfoStatus === "loading" && (
        <>
          <Skeleton.Input active size="small" />
          <Skeleton.Input active size="small" />
        </>
      )}

      {analyticsinfoStatus === "success" && (
        <>
          <DashboardBadge type="primary">{badge_text}</DashboardBadge>
          <DashboardPreviewInfo>{summary_text}</DashboardPreviewInfo>
        </>
      )}
    </>
  );
}

export default MarketPreview;
